module.exports = __webpack_public_path__ + "img/8.cba39e7e.jpg";